export default "__VITE_ASSET__lKFegKT6__"